"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListFilterComponent = ListFilterComponent;
exports.DateFilterComponent = DateFilterComponent;
exports.InputFilterComponent = InputFilterComponent;
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const React = __importStar(require("react"));
const moment_1 = __importDefault(require("moment"));
function ListFilterComponent({ selectedValues, disabled, values, onChange }) {
    return (React.createElement(Elements.SelectBox, { size: 6, value: selectedValues, multiple: true, disabled: disabled, onChange: onChange }, values.map(v => (React.createElement("option", { value: v.id, key: v.id },
        v.name,
        " (",
        v.id,
        ")")))));
}
function DateFilterComponent({ selectedStartDate, selectedEndDate, disabled, startDateOnChange, endDateOnChange }) {
    return (React.createElement(React.Fragment, null,
        React.createElement(DateComponent, { dateStringified: selectedStartDate, disabled: disabled, onChange: startDateOnChange }, "From"),
        React.createElement(DateComponent, { dateStringified: selectedEndDate, disabled: disabled, onChange: endDateOnChange }, "To")));
}
function InputFilterComponent({ value, disabled, children, onChange }) {
    return (React.createElement(Elements.InnerContainer, null,
        React.createElement(Elements.InputLabel, null, children),
        React.createElement(Elements.InputText, { type: "text", value: value, disabled: disabled, onChange: e => onChange(e.target.value) })));
}
function DateComponent({ children, disabled, dateStringified, onChange }) {
    return (React.createElement(Elements.InnerContainer, null,
        React.createElement(Elements.InputLabel, null, children),
        React.createElement("input", { type: "date", disabled: disabled, value: (0, moment_1.default)(dateStringified).format("YYYY-MM-DD"), onChange: e => onChange(e.target.valueAsDate.toISOString()) })));
}
//# sourceMappingURL=filter-component.js.map